"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCaptureStatusSite = exports.StudyCaptureStatusSubject = exports.StudyCaptureStatusVisit = exports.StudyAvailableVisit = exports.StudyCaptureStatusCrf = exports.StudyCaptureStatusActionType = void 0;
var StudyCaptureStatusActionType;
(function (StudyCaptureStatusActionType) {
    StudyCaptureStatusActionType["SDV"] = "SDV";
    StudyCaptureStatusActionType["Freezing"] = "FREEZING";
    StudyCaptureStatusActionType["ESign"] = "E-SIGN";
    StudyCaptureStatusActionType["Locking"] = "LOCKING";
})(StudyCaptureStatusActionType = exports.StudyCaptureStatusActionType || (exports.StudyCaptureStatusActionType = {}));
class StudyCaptureStatusCrf {
}
exports.StudyCaptureStatusCrf = StudyCaptureStatusCrf;
class StudyAvailableVisit {
}
exports.StudyAvailableVisit = StudyAvailableVisit;
class StudyCaptureStatusVisit {
}
exports.StudyCaptureStatusVisit = StudyCaptureStatusVisit;
class StudyCaptureStatusSubject {
}
exports.StudyCaptureStatusSubject = StudyCaptureStatusSubject;
class StudyCaptureStatusSite {
}
exports.StudyCaptureStatusSite = StudyCaptureStatusSite;
//# sourceMappingURL=studyCaptureStatus.js.map